import { Component, Input, EventEmitter } from '@angular/core';
import { BaseComponent } from '../BaseComponent';
import {
    LoggingService, TokenService, LocalStorageService,
    NotificationsService, AccountService,
    UserCreate, PlatformService
} from "@varsity/services";
import { ViewController, ToastController, NavParams, PopoverController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the PromoCodeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'promo-code',
    templateUrl: 'promo-code.html'
})
export class PromoCodeComponent extends BaseComponent {

    promoCodeValue: string;
    promoCodeApplyTrigger: (promo: string) => void;

    constructor(
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected accountService: AccountService,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected popoverCtrl: PopoverController,
        protected platformService: PlatformService,
        protected navParams: NavParams,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "PromoCodeComponent"
        );
        this.promoCodeValue = this.navParams.get("promoCode") || "";
        this.promoCodeApplyTrigger = this.navParams.get("promoCodeApply");
    }

    ngOnInit() {
        super.ngOnInit();
    }

    Close(): void {
        this.viewCtrl.dismiss();
    }

    triggerPromoCodeApply(): void {
        if (this.promoCodeValue && this.promoCodeValue.trim()) {
            this.promoCodeApplyTrigger(this.promoCodeValue);
            this.Close();
        } else {
            this.showNotification("Please provide a valid promo.", undefined, undefined, "warning");
        }
        
    }

}



// WEBPACK FOOTER //
// ./src/components/promo-code/promo-code.ts